import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useStepsForm } from "@refinedev/antd";
import { Form, Button } from "antd";
import { IApiKey } from "../../interfaces";
import { FormList } from "./form";

export const ApiKeyEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useStepsForm<IApiKey>();
  return (
    <>
      <Edit
        isLoading={queryResult?.isFetching}
        saveButtonProps={saveButtonProps}
        headerButtons={<Button onClick={() => history.back()}>Back</Button>}
      >
        <Form
          {...formProps}
          style={{ marginTop: 30 }}
          layout="vertical"
          initialValues={{
            ...formProps.initialValues,
          }}
        >
          <FormList formProps={formProps} />
        </Form>
      </Edit>
    </>
  );
};
